import React from 'react';
import { motion } from 'framer-motion';

const CornerOrnament = ({ className }: { className?: string }) => (
  <svg 
    viewBox="0 0 100 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
  >
    <defs>
      <linearGradient id="goldGradientPool" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="50%" stopColor="#F9E498" />
        <stop offset="100%" stopColor="#D4AF37" />
      </linearGradient>
    </defs>
    <path 
      d="M95 5C80 5 60 10 40 25C20 40 5 65 5 95" 
      stroke="url(#goldGradientPool)" 
      strokeWidth="2" 
      strokeLinecap="round"
    />
    <path 
      d="M75 15C85 10 95 10 95 25C95 40 85 45 75 40C65 35 65 20 75 15Z" 
      fill="url(#goldGradientPool)" 
      fillOpacity="0.1"
      stroke="url(#goldGradientPool)" 
      strokeWidth="0.8"
    />
    <path 
      d="M25 75C10 85 10 95 25 95C40 95 45 85 40 75C35 65 20 65 25 75Z" 
      fill="url(#goldGradientPool)" 
      fillOpacity="0.1"
      stroke="url(#goldGradientPool)" 
      strokeWidth="0.8"
    />
    <circle cx="95" cy="5" r="2" fill="url(#goldGradientPool)" />
    <circle cx="5" cy="95" r="2" fill="url(#goldGradientPool)" />
  </svg>
);

interface LuxuryImageFrameProps {
  children?: React.ReactNode;
  index?: number;
  className?: string;
  src?: string;
  alt?: string;
}

export const LuxuryImageFrame = ({ 
  children, 
  index = 0,
  className,
  src,
  alt
}: LuxuryImageFrameProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{
        duration: 0.9,
        delay: index * 0.1,
        ease: [0.21, 0.45, 0.32, 0.9],
      }}
      className={`relative w-full overflow-hidden ${className || ''}`}
    >
      <div className="relative p-0.5 sm:p-1.5 md:p-2 bg-[#FDFCF8] border-[0.5px] border-[#D4AF37]/20 shadow-md rounded-sm sm:rounded-md">
        <CornerOrnament className="absolute -top-1 -right-1 w-3 h-3 sm:w-8 sm:h-8 md:w-12 md:h-12 text-[#D4AF37]/40 opacity-40" />
        <CornerOrnament className="absolute -bottom-1 -left-1 w-3 h-3 sm:w-8 sm:h-8 md:w-12 md:h-12 text-[#D4AF37]/40 opacity-40 rotate-180" />
        <div className="absolute inset-0.5 border-[0.5px] border-[#D4AF37]/15 pointer-events-none" />

        <div className="relative aspect-[4/5] sm:aspect-square md:aspect-[16/10] overflow-hidden bg-[#f5f5f5] rounded-[2px] sm:rounded-sm">
          <motion.div
            whileHover={{ scale: 1.04 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="w-full h-full"
          >
            {src ? (
              <img
                src={src}
                alt={alt || ""}
                className="w-full h-full object-cover"
              />
            ) : children}
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};
